import { cn } from '@fshr/shared-react';
import './styles.scss';

export const ICONS = [
	'accessibility',
	'activities',
	'adventure',
	'africa-middle-east',
	'airline_check_in',
	'alarm',
	'alert',
	'arts_culture',
	'asia-pacific',
	'award_winning_spa',
	'arrow_left',
	'arrow_right',
	'arrow_right_large',
	'biodiversity_and_conservation',
	'banquet',
	'bathroom',
	'beach',
	'beds',
	'bellcart_luggage',
	'blizzard',
	'blowing_snow',
	'boardroom',
	'book',
	'brightness',
	'business_centre',
	'call',
	'call_alt',
	'call_alt_inverted',
	'call_circle_outline',
	'caret',
	'caret_down',
	'caret_up',
	'castle',
	'central-south-america',
	'chat',
	'chat_default_circle',
	'chat_notification',
	'chat_notification_large',
	'chat_outline',
	'check_in',
	'check_out',
	'checkmark',
	'checkmark_simple',
	'chevron_left',
	'chevron_right',
	'cloudy',
	'cloudy_fog',
	'cloudy_sunny_breaks',
	'classroom',
	'close',
	'close_alt',
	'close_circle',
	'cocktail',
	'cold',
	'collapse',
	'comfort',
	'commercial_flight',
	'condo',
	'contact_email',
	'contact_phone',
	'covid_testing',
	'credit_card',
	'culinary_experience',
	'dairy_free',
	'decor',
	'details',
	'detached_house',
	'diamond',
	'desktop',
	'dining',
	'dining_reservation',
	'diversity_inclusion_and_belonging',
	'diving_snorkeling',
	'documents_and_downloads',
	'douban',
	'download',
	'drizzle',
	'dress_code',
	'egg_free',
	'edit',
	'email',
	'email_fill',
	'energy_carbon_and_water_reduction',
	'energy_reduction',
	'enhanced_cleaning',
	'environment',
	'environmental_programs',
	'europe',
	'exclusive_amenities',
	'exclusive_amenities_filled',
	'exclusive_offer',
	'exclusives-buyouts',
	'experience',
	'express_pressing',
	'extension',
	'eye_closed',
	'eye_open',
	'eye_outline',
	'facebook',
	'facebook_tag',
	'family',
	'faqs',
	'festive_menu',
	'filter',
	'find_hotel_status',
	'fitness_facilities',
	'flight_arrival',
	'flight_departure',
	'flight_info',
	'floorplan',
	'fog',
	'fog-patches',
	'foursquare',
	'freezing_drizzle',
	'freezing_fog',
	'freezing_rain',
	'gallery',
	'gallery_external',
	'gluten_free',
	'governance',
	'golf',
	'googleplus',
	'hamburger',
	'hamburguer_small',
	'handshake',
	'haze_variable_clouds',
	'health_and_safety',
	'heart',
	'hollow_square',
	'horseback_riding',
	'hotel',
	'hot',
	'ice_pellets',
	'in-room_dining',
	'information',
	'instagram',
	'isolated_showers',
	'itinerary',
	'itinerary_default',
	'itinerary_new',
	'itinerary_notification',
	'item_add',
	'item_remove',
	'kids',
	'kitchen',
	'laundry',
	'late_checkout',
	'less_sign',
	'light_snow',
	'location_pin',
	'location_pin_brand',
	'location_pin_large_fill',
	'location_pin_small',
	'location_pin_small_fill',
	'lock',
	'luxury_bath_products',
	'mail',
	'mail_default_circle',
	'mainly_clear',
	'maintenance',
	'mask',
	'meetings_and_events',
	'mobile',
	'mobile_key',
	'more',
	'mountain',
	'multilingual_concierge',
	'my_neighborhood',
	'night_clear_cloudy',
	'night_cloudy',
	'night_cloudy_clear',
	'night_isolated_showers',
	'night_scattered_flurries',
	'night_scattered_showers',
	'night_snow_rain',
	'night_thunderstorm_chance',
	'no_available_date',
	'notes',
	'north-america',
	'nut_free',
	'occupancy',
	'offers',
	'order_grocery',
	'outbound',
	'outdoor-function-space',
	'outdoor_experience',
	'pagination_line',
	'parking',
	'partly_cloudy',
	'pause_button_large',
	'pause_button_small',
	'person',
	'pet',
	'pinterest',
	'play_button_large',
	'play_button_small',
	'photo_and_video',
	'plus_sign',
	'plus_thin',
	'pool',
	'pool_alt',
	'pillow',
	'premium_wifi',
	'pr_and_hotel',
	'pressreader',
	'private_flight',
	'private_jet',
	'private_retreats',
	'property_info',
	'purchasing_practices',
	'qq',
	'quotation_marks_l',
	'quotation_marks_outline',
	'quotation_marks_s',
	'rain',
	'ramdan_menu',
	'reception',
	'recommendations',
	'refreshments',
	'resi_residence',
	'residence',
	'residence_a_la_carte',
	'residence_dining',
	'residence_my_building',
	'residence_services',
	'resort',
	'resort-urban',
	'resort_activities',
	'room_cleaning',
	'room_upgrade',
	'safety_and_security',
	'safety_and_security_inverted',
	'scattered_flurries',
	'scattered_showers',
	'search',
	'services_and_amenities',
	'settings',
	'shoe',
	'shopping',
	'shopping_cart',
	'shopping_cart_outlined',
	'showers',
	'shuttle_bus_schedule',
	'ski',
	'smoke_free',
	'snow',
	'snow_rain',
	'snow_rain_showers',
	'snow_squalls',
	'social',
	'spa',
	'sporting_events',
	'standard_wifi',
	'storage',
	'sunny',
	'sunny_cloudy',
	'support_staff',
	'surfing',
	'sustainable_food_and_beverage',
	'sustainable_travel',
	'switch_view',
	'tablet',
	'takeaway',
	'telephone_directory',
	'temperature_check',
	'tennis',
	'terms_and_conditions',
	'theatre',
	'thunderstorm',
	'thunderstorm_chance',
	'time',
	'tours',
	'townhouse',
	'transportation',
	'tray_removal',
	'tree',
	'tree_large',
	'tripadvisor',
	'turn_down_service',
	'tv_channel_listings',
	'twitter',
	'u_shape',
	'unique_stays',
	'urban',
	'valet_parking',
	'vegan',
	'vegetarian',
	'variable_clouds',
	'views',
	'washer',
	'waste_reduction',
	'water_reduction',
	'wechat',
	'weddings',
	'weibo',
	'wellness',
	'wet_snow',
	'whats_included',
	'wine',
	'windy',
	'yacht',
	'yoga',
	'youku',
	'youtube',
] as const;

export type IconType = (typeof ICONS)[number];

interface IconProps {
	icon: IconType;
	className?: string;
}

export default function Icon({ icon, className }: IconProps) {
	return <span className={cn(`icon icon-${icon} grid place-content-center`, className)} />;
}
